(() => {
  if (window.vaslInquiryLoaded) return;
  window.vaslInquiryLoaded = true;
  function init(root) {
    if (root.dataset.inquiryReady) return;
    root.dataset.inquiryReady = 'true';
    const endpoint = root.dataset.endpoint;
    if (!endpoint) return;
    const form = root.querySelector('form');
    const status = root.querySelector('[data-inquiry-status]');
    const submit = root.querySelector('[data-inquiry-submit]');
    let requestId;
    form.addEventListener('input', () => {requestId = undefined;});
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!form.reportValidity() || submit.disabled) return;
      let target;
      try {
        target = new URL(endpoint, location.origin);
        if (target.origin !== location.origin || !target.pathname.startsWith('/apps/')) throw new Error('Invalid endpoint');
      } catch {status.textContent = 'This form connection is unavailable. Please email sales@vaslperformance.com.'; return;}
      const fields = new FormData(form);
      const payload = {
        request_id: requestId ||= crypto.randomUUID(),
        build_id: root.dataset.buildId,
        case_id: root.dataset.caseId,
        name: fields.get('contact[name]'),
        email: fields.get('contact[email]'),
        phone: fields.get('contact[phone]'),
        vehicle: fields.get('contact[Your vehicle]'),
        finish: fields.get('contact[Preferred finish]'),
        message: fields.get('contact[body]'),
        marketing_consent: fields.get('marketing_consent') === 'true',
        consent_version: 'vasl-case-inquiry-2026-10-04'
      };
      submit.disabled = true;
      status.textContent = 'Sending your inquiry…';
      try {
        const response = await fetch(target.href, {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload), signal:AbortSignal.timeout(20000)});
        const result = await response.json();
        if (!response.ok || result.accepted !== true || !result.inquiry_id || result.request_id !== payload.request_id) throw new Error('Not confirmed');
        status.textContent = 'Thank you. VASL Performance has received your inquiry.';
        if (payload.marketing_consent && result.marketing_status === 'pending') status.textContent += ' Check your inbox to confirm your email subscription.';
        else if (payload.marketing_consent && result.marketing_status !== 'subscribed') status.textContent += ' Your email subscription has not been confirmed.';
        form.reset(); requestId = undefined;
      } catch {status.textContent = 'We could not confirm your submission. Please retry or email sales@vaslperformance.com.';}
      finally {submit.disabled = false;}
    });
  }
  const scan = (scope = document) => scope.querySelectorAll('[data-case-inquiry]').forEach(init);
  scan(); document.addEventListener('shopify:section:load', event => scan(event.target));
})();
